import { Button, styled } from '@/theme/index';

const FooterContent = styled('div')(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  paddingTop: theme.spacing(1),
}));

const SubmitFormButton = styled(Button)(({ theme }) => ({
  width: '50%',
  '&.Mui-disabled': {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.primary.contrastText,
    opacity: 0.5,
  },
}));

type ComplianceFormFooter = {
  disable?: boolean;
  isSigning: boolean;
};

export function ComplianceFormFooter({
  disable = false,
  isSigning = false,
}: ComplianceFormFooter) {
  return (
    <FooterContent>
      <SubmitFormButton
        type="submit"
        variant="contained"
        color="success"
        role="button"
        aria-label="compliance-submit-button"
        disabled={disable || isSigning}
      >
        {isSigning ? 'Reactivating' : 'Submit Form'}
      </SubmitFormButton>
    </FooterContent>
  );
}
